<template>
  <default-modal
    v-model="modalOpened"
    name="settle-project"
    :title="$t('settle_project')"
    :actionLabel="$t('settle_hours')"
    :successHandler="handleSettle"
  >
    <template slot="content">
      <p>{{ $t('settle_project_modal_grouping') }}</p>

      <q-list link class="no-border">
        <q-item v-if="showFixedOption" tag="label">
          <q-item-side>
            <q-radio v-model="formData.grouping" val="fixed"/>
          </q-item-side>

          <q-item-main>
            <q-item-tile title>{{ $t('settle_project_modal_grouping_fixed') }}</q-item-tile>
          </q-item-main>
        </q-item>

        <q-item tag="label">
          <q-item-side>
            <q-radio v-model="formData.grouping" val="summary"/>
          </q-item-side>

          <q-item-main>
            <q-item-tile title>{{ $t('settle_project_modal_grouping_all') }}</q-item-tile>
          </q-item-main>
        </q-item>

        <q-item tag="label">
          <q-item-side>
            <q-radio v-model="formData.grouping" val="description"/>
          </q-item-side>

          <q-item-main>
            <q-item-tile label>{{ $t('settle_project_modal_grouping_activity') }}</q-item-tile>
          </q-item-main>
        </q-item>

        <q-item tag="label">
          <q-item-side>
            <q-radio v-model="formData.grouping" val="individual"/>
          </q-item-side>

          <q-item-main>
            <q-item-tile label>{{ $t('settle_project_modal_grouping_individual') }}</q-item-tile>
          </q-item-main>
        </q-item>
      </q-list>

      <q-field>
        <q-select
          v-model="formData.rounding"
          :options="roundingOptions"
          name="rounding"
          :placeholder="$t('settle_project_modal_rounding')"
          :float-label="$t('settle_project_modal_rounding')"
        />
      </q-field>
    </template>
  </default-modal>
</template>

<script>
  import DefaultModal from 'components/Modal/DefaultModal.vue'
  import { projectTypes } from 'src/utils/projectTypes'

  export default {
    props: {
      project: {
        required: false
      }
    },

    data () {
      return {
        formData: {
          grouping: this.showFixedOption ? 'fixed' : 'description',
          rounding: '2'
        },
        modalOpened: false
      }
    },

    computed: {
      showFixedOption () {
        return this.project ? this.project.project_type === projectTypes.FIXED_FEE : false
      },
      roundingOptions () {
        return [
          { label: '15 min', value: '4' },
          { label: '30 min', value: '2' },
          { label: '1 h', value: '1' }
        ]
      }
    },

    methods: {
      show () {
        this.modalOpened = true
      },

      handleSettle () {
        this.$emit('settle-project', { grouping: this.formData.grouping, rounding: this.formData.rounding })

        this.modalOpened = false
      }
    },

    components: {
      DefaultModal
    }
  }
</script>
